import React from 'react';
import { Gateway, ValidationResult } from '../../types/dynamicRouting';
import { useGetMerchantConfigsByAMCQuery } from '@/services/api';
import { useAMC } from '@/context/AMCContext';

interface GatewaysEditorProps {
  gateways: Gateway[];
  onChange: (gateways: Gateway[]) => void;
  validationResult?: ValidationResult;
  collapseSignal?: number;
}

const GatewaysEditor: React.FC<GatewaysEditorProps> = ({
  gateways,
  onChange,
}) => {
const { amcId} = useAMC();


const { data: merchantConfigs, isLoading} = useGetMerchantConfigsByAMCQuery(amcId!, { skip: !amcId });


  React.useEffect(() => {
    if (merchantConfigs && merchantConfigs.length > 0) {
      // Map only id and name
      const loadedGateways: Gateway[] = merchantConfigs.map(cfg => ({
        id: cfg.id!,
        name: cfg.aggregator,
      }));

    // Check if current gateways already match
    // Update parent state once
    const areEqual = JSON.stringify(loadedGateways) === JSON.stringify(gateways);
    if (!areEqual) {
      onChange(loadedGateways);
  }
    }
  }, [merchantConfigs, onChange,gateways]);

  if (isLoading) {
    return <div>Loading gateways...</div>;
  }

  return null
};

export default GatewaysEditor;
